module.exports = __webpack_public_path__ + "media/videocall_ringtone.9a765f88.mp3";